// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /profile/get-for-account.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeProfileGetForAccountBody,
  typeProfileGetForAccountOutput200,
} from "../../sdk/profile/postProfileGetForAccount";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildProfileGetForAccountQueryKey(
  payload: typeProfileGetForAccountBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`accountId:${JSON.stringify(payload.accountId)}`);
  return [
    "post:profile:profileGetForAccount",
    "svc:profile-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeProfileGetForAccountOutput200,
    unknown,
    typeProfileGetForAccountOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useProfileGetForAccount(
  payload: typeProfileGetForAccountBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildProfileGetForAccountQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postProfileGetForAccount(payload),
    ...resolvedOptions,
  });
}
